<div class="row mb-3">
    <div class="col-md-8">
        <h3>{{pageTitle}}</h3>
    </div>
    <div class="col-md-4">
        <span class="float-right ml-auto">
            <button class="btn btn-default" type="button" *ngIf="categoryMappingList && 
            categoryMappingList.length > 0 && pageMode ==='edit'" (click)="goToViewMapping();">
                View Category Mapping
            </button>

            <button class="btn btn-default" type="button" *ngIf="categoryMappingList && 
            categoryMappingList.length > 0 && pageMode ==='view' && !showAdd" (click)="goToEditMapping();">
                Edit Category Mapping
            </button>
            <button class="btn btn-default" type="button" *ngIf="categoryMappingList && 
            categoryMappingList.length > 0 && pageMode ==='view' && showAdd" (click)="goToAddMapping();">
                Add Category Mapping
            </button>
        </span>
    </div>
</div>
<div class="category-mapping-page">
    <div class="row">
        <div class="col-md-12 mt-2">
            <div class="row" *ngFor="let alert of alerts" class="padding-b-15">
                <div class="alert alert-dismissible" [ngClass]="{'alert-danger': alert.type === 'error','alert-success': alert.type === 'success'}">
                    <button type="button" class="close" data-dismiss="alert" (click)="closeAlerts()">×</button>
                    {{ alert.msg }}
                </div>
            </div>
        </div>
    </div>
    <div class="mb-4" [ngStyle]="{'opacity': setOpacity ? '0.7':'1'}">
        <div class="row col-12 mt-2">
            <div class="col-5">
                <mat-label>Content Type :</mat-label>
                <mat-radio-group class="col-md-12" aria-label="Content Type" name="featureType" [(ngModel)]="selectedContentType" (change)="contentTypeChange()"
                    required>
                    <mat-radio-button *ngFor="let contentObj of contentTypes" [value]="contentObj.value">{{contentObj.name}}</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
        <div class="row col-12 m-0" *ngIf="connectedSupportTopics && audioSupportTopics && audioSupportTopics.length === 0 && 
        connectedSupportTopics.length === 0">
            {{ "Label.category_mapping_not_available" | translate}}</div>

        <div class="row mt-4" *ngIf="connectedSupportTopics && audioSupportTopics && (connectedSupportTopics.length > 0 || 
        audioSupportTopics.length > 0)">
            <div class="col-5">
                <div cdkDropList class="example-list" (cdkDropListDropped)="dropAudioSupportTopics($event)">
                    <div class="category-header" *ngIf="selectedApplication === 'toyota'">Audio Multimedia</div>
                    <div class="category-header" *ngIf="selectedApplication === 'lexus'">Lexus Multimedia</div>
                    <div class="example-box" [ngStyle]="{'cursor': pageMode === 'view' || setOpacity ? 'default':'move'}" *ngFor="let obj of audioSupportTopics"
                        [cdkDragDisabled]="pageMode === 'view'" cdkDrag>{{obj.featureName}}</div>
                </div>
            </div>
            <div class="col-5">
                <div cdkDropList class="example-list" (cdkDropListDropped)="dropConnectedSupportTopics($event)">
                    <div class="category-header" *ngIf="selectedApplication === 'toyota'">Connected Services</div>
                    <div class="category-header" *ngIf="selectedApplication === 'lexus'">Enform Services</div>
                    <div class="example-box" [ngStyle]="{'cursor': pageMode === 'view' || setOpacity ? 'default':'move'}" *ngFor="let obj of connectedSupportTopics"
                        [cdkDragDisabled]="pageMode === 'view'" cdkDrag>{{obj.featureName}}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="row" style="margin-top: 30px;" *ngIf="categoryMappingList && categoryMappingList.length > 0 &&  pageMode !== 'view'">
        <div class=" col-12 action-controls ">
            <span *ngIf="pageMode !=='view' ">
                <button class="btn btn-default " (click)="onSave(); ">Save</button>
            </span>
            <span class="ml-2 " *ngIf="pageMode !=='view' ">
                <button class="btn btn-secondary " (click)="onCancel(); ">Cancel</button>
            </span>
        </div>
    </div>

</div>